// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DunningController = function ($scope, $routeParams, Dunning, DunningDownload, DunningResend, DunningBearerMedium,
    Customer, DunningDownloadByFilter, gettextCatalog, gettext, DunningsCount, DunningSettings, DocumentTemplate,
    DatepickerUtils, PUtill) {
    $scope.isL = false;
    $scope.dateRange = { dateFrom: null, dateTo: null };
    $scope.search = "";
    $scope.templateId = "";
    $scope.customerId = ($routeParams.customerId || '');
    
    $scope.hideDunningCounter = false;
    
    function getSearchParams() {
        var searchParams = {
            search: $scope.search,
            customerId: $scope.customerId,
            drafts: false,
            templateId: $scope.templateId
        };

        DatepickerUtils.setSearchParamsWithStringRangeAndRaiseErrorIfNeeded($scope, searchParams, $scope.dateRange);

        return searchParams;
    }
    
    function isFilterEmpty(searchParams){
        for(var it in searchParams) {
            if(searchParams.hasOwnProperty(it) && searchParams[it]) {
                return false;
            }
        }
        return true;
    }
   
    $scope.updateFilter = function (func) {
        var searchParams = getSearchParams();
        $scope.documents = $scope.paginator(function (options, callback) {
            return Dunning.query(options, function () {
                callback();
                if (func)
                    func();
                func = null;
                if(!($scope.hideDunningCounter = !isFilterEmpty(searchParams))) {
                    updatedDunningsCount();
                }
            });
        }, searchParams, 20);
    };

    $scope.navigation = 'partials/documents-navigation.html' + $scope.linkVersion;
    $scope.doctype = 'dunnings';
    $scope.updateFilter();

    $scope.download = function (id) {
        var downloadInfo = new DunningDownload();
        downloadInfo.$save({ dunningId: id }, function () {
            window.location = downloadInfo.Url;
        });
    };

    $scope.resend = function (id) {
        DunningBearerMedium.get({ dunningId: id }, {}, function (data) {
            var bearerMedium = data.BearerMedium,
                bearerMediumTranslated = gettextCatalog.getString(bearerMedium),
                dialogTitle = gettextCatalog.getString('Resend Document');

            if (bearerMedium != "ArchiveOnly") {

                $scope.yesCancel(dialogTitle,
                    gettextCatalog.getString(gettext('Do you want to resend the document using')) + ' ' + bearerMediumTranslated + '?',
                    function () {
                        DunningResend.save({ dunningId: id }, {}, null);
                    });

            } else {
                $scope.onlyCancel(dialogTitle, gettextCatalog.getString(gettext("Can not resend document, settings are for archiving only.")));
            }
        });
    };
    
    var docType = "Dunning";
    $scope.dunningSettings = DunningSettings.get();
    var loadTemplates = function () {
         DocumentTemplate.query({ documentType: docType }, function (data) {
             $scope.templates = data;
        });
    }
    $scope.downloadByFilter = function () {
        if ($scope.isL)
            return;

        var searchParams = getSearchParams();
        searchParams.isDownload = true;
        var download = function () {

            $scope.isL = true;
            var downloadInfo = new DunningDownloadByFilter();
            downloadInfo.$save({
                isDownload: true,
                search: searchParams.search,
                dateFrom: searchParams.dateFrom,
                dateTo: searchParams.dateTo,
                templateId: searchParams.templateId,
                customerId: searchParams.customerId,
                drafts: searchParams.drafts
            }, function () {
                switch (true) {
                case downloadInfo.IsFileCountExceeded:
                    $scope.notify("warning", gettextCatalog.getString(gettext("The maximum permissible number of documents 5000. Please refine your filter criteria.")));
                    break;
                case downloadInfo.IsFileCountZero:
                    $scope.notify("warning", gettextCatalog.getString(gettext("No files match search criteria.")));
                    break;
                default:
                    $scope.downloadFile(downloadInfo.Url);
                    break;
                }
                $scope.isL = false;
                $scope.isL = false;
            }, function () { $scope.isL = false; });
        };
        $scope.updateFilter(download);
    };

    $scope.dunningsCount = 0;
    function updatedDunningsCount() {
        DunningsCount.get(getSearchParams(), function (data) {
            $scope.dunningsCount = (data && data.Count) ? data.Count : 0;
        });
    }

    loadTemplates();

    if ($scope.customerId)
        $scope.customer = Customer.get({ customerId: $scope.customerId });
};
DunningController.$inject = ['$scope', '$routeParams', 'Dunning', 'DunningDownload', 'DunningResend',
    'DunningBearerMedium', 'Customer', 'DunningDownloadByFilter', 'gettextCatalog', 'gettext',
    'DunningsCount', 'DunningSettings', 'DocumentTemplate', 'DatepickerUtils', 'PUtill'];
